module.exports = __webpack_public_path__ + "static/allergy2-a49c9abef326aac0724e140b303a88e4.png";